import { render, staticRenderFns } from "./Term.vue?vue&type=template&id=7b4c55d6&scoped=true"
import script from "./Term.vue?vue&type=script&lang=js"
export * from "./Term.vue?vue&type=script&lang=js"
import style0 from "./Term.vue?vue&type=style&index=0&id=7b4c55d6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4c55d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b4c55d6')) {
      api.createRecord('7b4c55d6', component.options)
    } else {
      api.reload('7b4c55d6', component.options)
    }
    module.hot.accept("./Term.vue?vue&type=template&id=7b4c55d6&scoped=true", function () {
      api.rerender('7b4c55d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/register/Term.vue"
export default component.exports